import { carryWorkQueueOrigin } from './workQueueReturn';

// Keep the appealed application explicit; a case may contain several applications.
export const appealWorkspacePath = (appeal, location) => {
  const applicationId = appeal.originalDecision?.applicationId;
  const base = applicationId ? `/application-case/${appeal.caseId}` : `/cases/${appeal.caseId}`;
  const params = new URLSearchParams();
  if (applicationId) params.set('applicationId', applicationId);
  params.set('appeal', appeal.id);
  return carryWorkQueueOrigin(`${base}?${params}`, location);
};

export const withAppeal = (path, appealId, location) => {
  const [base, search = ''] = path.split('?');
  const params = new URLSearchParams(search);
  params.set('appeal', appealId);
  return carryWorkQueueOrigin(`${base}?${params}`, location);
};

export const openAppealWindow = (caseId, appealId = 'open') => window.dispatchEvent(
  new CustomEvent('appeals:open', { detail: { caseId, appealId } })
);
